import axios from 'axios';

/**
 * 백엔드 서버에게 서명 검증을 요청하는 함수
 * @param {Object} param0
 * @param {String} param0.serviceId
 * @param {String} param0.state
 * @param {String} param0.code
 * @param {String} param0.type
 * @param {String} param0.data
 * @param {String} param0.signature
 * @param {String} param0.did
 * @return {Promise<Boolean>} 서명 검증 결과
 */
async function verifySignature({ serviceId, state, code, type, data = '', signature, did }) {

  if (typeof serviceId !== 'string' || typeof state !== 'string' || typeof code !== 'string'
   || typeof type !== 'number' || typeof data !== 'string' || typeof signature !== 'string' || typeof did !== 'string') {
     throw new TypeError('Invalid \'verifySignature\' parameter type');
   }

  try {
    const res = await axios.post('/api/v1/verify/signature', {
      service_id: serviceId, state, code, type, data, signature, did,
    });
    if (res.data && res.data.data && res.data.data.result && typeof res.data.data.result == 'boolean') {
      // 서명 검증 결과 반환
      return res.data.data.result;
    } else {
      return false;
    }
  } catch (err) {
    console.log(JSON.stringify(err.response, null, 4));
    return false;
  }
}

export default verifySignature;